import React from 'react';
import { useIntl } from 'react-intl';

import { SfaFatalError } from '@futrli/shared-services';

import image from './images/internal-error.svg';

export const SfaNoWorkspacesFatalError = () => {
  const intl = useIntl();

  const text = {
    title: intl.formatMessage({
      id: 'onboarding.sfa.no_workspace_found',
      defaultMessage: 'No workspace found'
    }),
    subtitle: intl.formatMessage({
      id: 'onboarding.sfa.no_access_to_any_futrli_workspace',
      defaultMessage: 'You currently do not have access to any Futrli workspace.'
    }),
    text: intl.formatMessage({
      id: 'onboarding.sfa.if_not_expected_contact_workspace_admin_or_futrli_support',
      defaultMessage:
        'If this is not expected, please contact your workspace administrator, or contact the Futrli Support Team.'
    })
  };

  return <SfaFatalError image={image} {...text} />;
};
